import { z } from 'zod';

// The one reader of import.meta.env. Parsed once at boot in app/providers.tsx.
const envSchema = z.object({
  VITE_API_URL: z.string().min(1).default('/graphql'),
  VITE_MARKETING_URL: z.url().default('https://macswarm.com'),
  VITE_MOCK_API: z
    .enum(['true', 'false'])
    .default('false')
    .transform((value) => value === 'true'),
  // Analytics: the website's GA4 property and PostHog project, so site and app count one visit.
  VITE_GA_MEASUREMENT_ID: z.string().default('G-BL2YZQ106E'),
  VITE_POSTHOG_TOKEN: z.string().default('phc_uE75LJeFMQ3jkymqzt6RhkK8JxAqw93jnb2AZbPFpQCZ'),
  VITE_POSTHOG_HOST: z.url().default('https://macswarm.com/ph'),
  // Hosts that report; anywhere else events go to the console only.
  VITE_ANALYTICS_HOSTS: z
    .string()
    .default('app.macswarm.com')
    .transform((value) =>
      value
        .split(',')
        .map((host) => host.trim())
        .filter(Boolean),
    ),
});

export type Env = z.infer<typeof envSchema>;

export function parseEnv(source: Record<string, unknown>): Env {
  const result = envSchema.safeParse(source);
  if (!result.success) {
    const fields = result.error.issues.map((issue) => issue.path.join('.')).join(', ');
    throw new Error(`Invalid environment: ${fields}`);
  }
  return result.data;
}

export const env: Env = parseEnv({
  VITE_API_URL: import.meta.env.VITE_API_URL || undefined,
  VITE_MARKETING_URL: import.meta.env.VITE_MARKETING_URL || undefined,
  VITE_MOCK_API: import.meta.env.DEV ? import.meta.env.VITE_MOCK_API || undefined : 'false',
  VITE_GA_MEASUREMENT_ID: import.meta.env.VITE_GA_MEASUREMENT_ID || undefined,
  VITE_POSTHOG_TOKEN: import.meta.env.VITE_POSTHOG_TOKEN || undefined,
  VITE_POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST || undefined,
  VITE_ANALYTICS_HOSTS: import.meta.env.VITE_ANALYTICS_HOSTS || undefined,
});
